export default {
  totalInventoryExpiredList: [],
  totalInventoryExpiredCount: 0
}
